/** GENERATED by libs/shared-ui/src/icons/generate-icons.js — do not edit. Run `npm run generate-icons`. */

export const CUSTOM_ICON_NAMES = [
  'arrow-split',
  'bank',
  'calendar-exclamation',
  'card-view',
  'checkmark',
  'coins',
  'cookie',
  'cross',
  'deal-expiring',
  'deal-initial',
  'diamond',
  'epc-improvements',
  'excavator',
  'family',
  'file-with-magnifying-glass',
  'further-advance',
  'gauge',
  'hand-person',
  'hand-with-house',
  'heating',
  'home-renovation',
  'key-square-arrow-enter',
  'key-square-control',
  'key-square-escape',
  'key-square-meta',
  'loan-secured',
  'loan-unsecured',
  'menu-dots-vertical',
  'merge-square',
  'minus',
  'mortgage',
  'person-with-arrows',
  'pig-coin',
  'pipeline',
  'plus',
  'price-note',
  'unicorn-flag',
  'valuation-confidence-high',
  'valuation-confidence-low',
  'valuation-confidence-medium',
  'wall',
  'window',
] as const;

export const CUSTOM_ICON_NAME_SET: ReadonlySet<string> = new Set(CUSTOM_ICON_NAMES);

export const CUSTOM_SPRITE_PATH = 'assets/shared-ui/icons/symbol-defs.svg';
